/* eslint-disable no-undef */
export default {
	name: "bootstrap-select",
	props: ["selectOptions", "selectedOption", "elementId", "returnSelectedOptionText", "listIsStringsOnly", "disabled", "optionsSize"],
	emits: ["changeSelect"],
	data() {
		return {
			selectElementId: "select",
			selectedValue: null,
			sizeOfOptions: "5",
			hide: false,
			options: [],
		};
	},
	methods: {
		onSelectValueChange() {
			console.log("change");
			if (this.returnSelectedOptionText) {
				if(this.selectedValue !== null && this.selectedValue !== ""){
					if(this.selectOptions !== null && this.selectOptions !== undefined && this.selectOptions.length > 0) {
						var selectedText = this.selectOptions.find(option => option.id === this.selectedValue).text;
						var selectedOption = {
							id: this.selectedValue,
							text: selectedText
						};
						this.$emit("changeSelect", selectedOption);
					}
					
				}
			}
			else {
				this.$emit("changeSelect", this.selectedValue);
			}
		},
		reintialiseSelect(){
			var self = this;
			setTimeout(function () {
				var elementId = "#" + self.elementId;
				$(elementId).selectpicker("val", self.selectedValue);
				$(elementId).selectpicker("refresh");
			}, 200);
		}
	},
	mounted: function () {
		
	},
	watch: {
		selectOptions: {
			handler: function () {
				this.reintialiseSelect();
			},
			immediate: true,
			deep: true
		},
		selectedOption: {
			handler: function () {
				var self = this;
				this.selectedValue = this.selectedOption;
                
				setTimeout(function () {
					var elementId = "#" + self.elementId;
					$(elementId).selectpicker("render");
				}, 200);
			},
			immediate: true,
			deep: true
		},
		disabled:{
			handler: function () {
				this.reintialiseSelect();
			},
			immediate: true,
			deep: true
		},
		optionsSize:{
			handler: function () {
				if(this.optionsSize){
					this.sizeOfOptions = this.optionsSize;
				}
			},
			immediate: true,
			deep: true
		}
	}
};